import React from 'react';
import { Button, Col, Row, ModalBody, Form } from 'reactstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import {
	addFiscalYearWithPeriods,
	updateFiscalYear,
} from '../../../../slices/fiscalYear/thunk';
import OInput from '../../../../Components/OElements/OInput';

const FiscalYearForm = ({ dataFiscalYear, isEdit, handleToggleModal }) => {
	const dispatch = useDispatch();

	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {
			name: dataFiscalYear?.name || '',
			description: dataFiscalYear?.description || '',
			start_date: dataFiscalYear?.start_date
				? dataFiscalYear.start_date.split('T')[0]
				: '',
			end_date: dataFiscalYear?.end_date
				? dataFiscalYear.end_date.split('T')[0]
				: '',
		},
		validationSchema: Yup.object({
			name: Yup.string().required('Campo requerido'),
			start_date: Yup.string().required('Campo requerido'),
			end_date: Yup.string()
				.required('Campo requerido')
				.test(
					'is-after-start-date',
					'La fecha de fin no puede ser anterior a la fecha de inicio',
					function (value) {
						const { start_date } = this.parent;
						return new Date(value) >= new Date(start_date);
					}
				),
		}),
		onSubmit: values => {
			if (isEdit) {
				const updatedFiscalYear = {
					_id: dataFiscalYear._id,
					...values,
				};
				dispatch(updateFiscalYear(updatedFiscalYear));
			} else {
				dispatch(addFiscalYearWithPeriods(values));
			}
			handleToggleModal();
		},
	});

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<Row className='g-3'>
					<Col lg={12}>
						<OInput
							name='name'
							label='Nombre del Año Fiscal'
							type='text'
							validation={validation}
							isRequired={true}
						/>
					</Col>
					<Col lg={12}>
						<OInput
							name='description'
							label='Descripción'
							type='textarea'
							validation={validation}
						/>
					</Col>
					<Col lg={6}>
						<OInput
							name='start_date'
							label='Fecha de Inicio'
							type='date'
							validation={validation}
							isRequired={true}
						/>
					</Col>
					<Col lg={6}>
						<OInput
							name='end_date'
							label='Fecha de Fin'
							type='date'
							validation={validation}
							isRequired={true}
						/>
					</Col>
				</Row>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={handleToggleModal}
						className='btn-danger btn-label'
					>
						<i className='icon-x label-icon'></i>
						Cancelar
					</Button>
					<button type='submit' className='btn btn-label btn-primary'>
						<i className='ri-save-3-line label-icon'></i>
						{isEdit ? 'Editar' : 'Crear'}
					</button>
				</div>
			</div>
		</Form>
	);
};

export default FiscalYearForm;
